import { render, staticRenderFns } from "./GuardNotifications.vue?vue&type=template&id=74d2f57e&"
import script from "./GuardNotifications.vue?vue&type=script&lang=ts&"
export * from "./GuardNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./GuardNotifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports